import {LANGUAGES} from "./medicEndpoints";
import {http} from "../../services/http";

class MedicApi {

    async updateMedicLanguages(languageIds: number[]) {
        return await http.put<void>(LANGUAGES, {languageIds});
    }
}

export const medicApi = new MedicApi();
